"use client";

import { useEffect } from "react";
import { trackTime, trackView } from "@/lib/analytics";

export function TimeTracker({ slug }: { slug: string }) {
  useEffect(() => {
    trackView(slug);
    let totalMs = 0;
    let segmentStart = Date.now();

    const handleVisibility = () => {
      if (document.hidden) {
        totalMs += Date.now() - segmentStart;
      } else {
        segmentStart = Date.now();
      }
    };

    const flush = () => {
      if (!document.hidden) totalMs += Date.now() - segmentStart;
      trackTime(slug, totalMs);
    };

    document.addEventListener("visibilitychange", handleVisibility);
    window.addEventListener("pagehide", flush);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("pagehide", flush);
      flush();
    };
  }, [slug]);

  return null;
}
